export default __webpack_public_path__ + "a044213fa563345281844d467c02442d.png";